import { type FitViewOptions, MarkerType } from '@xyflow/react';

export const fitViewOptions: FitViewOptions = {
	padding: 0.1,
	minZoom: 0.1,
	includeHiddenNodes: true,
	maxZoom: 4
};

export const defaultEdgeOptions = {
	animated: false,
	type: 'bezier',
	style: {
		strokeWidth: 2
	},
	markerEnd: {
		type: MarkerType.Arrow
	}
};
